"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLaunchpadProvider = exports.LaunchpadProvider = void 0;
var constate_1 = __importDefault(require("constate"));
function useLaunchpad(_a) {
    var chains = _a.chains, defaultChain = _a.defaultChain, chainNodes = _a.chainNodes, mainToken = _a.mainToken, levels = _a.levels, salePools = _a.salePools, registry = _a.registry, _b = _a.defaultSale, defaultSale = _b === void 0 ? {} : _b;
    var defaultChainConfig = chains.find(function (c) { return c.symbol === defaultChain; });
    return {
        chainNodes: chainNodes,
        chains: chains,
        defaultChain: defaultChainConfig,
        mainToken: mainToken,
        levels: levels,
        salePools: salePools,
        registry: registry,
        defaultSale: defaultSale,
    };
}
exports.LaunchpadProvider = (_a = (0, constate_1.default)(useLaunchpad), _a[0]), exports.useLaunchpadProvider = _a[1];
